import React, { useState } from "react";
import { WidthProvider, Responsive } from "react-grid-layout";
import Widget from "../Layout/widget";
import Calendar from "../components/Calendar/calendar";
import CoverPage from "./CoverPage/CoverPage";
import WebView from "../components/WebView/webview";
import BannerPreview from "../components/Banner/banner";
import { widgetTypes } from "../utils/constants";
import IconLauncher from "../components/IconLauncher/IconLauncher";
import "react-grid-layout/css/styles.css";
import "./dashboard.css";
import CustomTab from "../components/CustomTab/CustomTab";
import analytics from "../utils/analytics";
import SieraDashboard from "./SieraDashboard/SieraDashboard";
import infoIcon from "../assets/icons/info_icon.svg"

const ResponsiveGridLayout = WidthProvider(Responsive);
const Dashboard = ({
  layoutJSON = [],
  coverPageData = {},
  dashboards,
  activeDashboard = {},
  setActiveDashboard,
  smartviewsConfig,
}) => {
  const [forceRefresh, setForceRefresh] = useState(1);
  const isRestrictedWidget = (config) =>
    config?.entity?.id === "smartviews" && !smartviewsConfig?.tabs?.find((tab) => tab?.id === config?.smartViewTab?.id);
  let flag = 20;

  const onDashboardChange = (data) => {
    setActiveDashboard(data);
    const analyticsData = {
      category: "tab_change",
      type: "click",
    };
    analytics.sendEvent("Dashboard tab changed", analyticsData);
  };
  
  return (
    <div className="dashboard-container" style={{ position: "relative" }}>
      <div className="custom-navbar">
        <CustomTab dashboards={dashboards} activeDashboard={activeDashboard} setActiveDashboard={onDashboardChange} />
      </div>

      {activeDashboard?.type === "SIERA" ? (
        <SieraDashboard activeDashboard={activeDashboard} />
      ) : (
        <>
          <div className="smallSreenSizeWarning ng_p_1_r">
            <img src={infoIcon} alt="info-icon" className="infoIcon" />
            <span>Please zoom out for a better Casa experience. Homepage is optimized for laptop or desktop.</span>
          </div>
          <CoverPage
            coverPageData={coverPageData}
            activeDashboard={activeDashboard}
            setForceRefresh={setForceRefresh}
          />
          <div className="container main">
            <ResponsiveGridLayout
              className="layout"
              layouts={{ lg: layoutJSON }}
              breakpoints={{ lg: 956, xxs: 320}}
              cols={{ lg: 16, xxs: 4}}
              rowHeight={20}
              margin={[15, 20]}
              containerPadding={[5, 10]}
              isDraggable={false}
              isResizable={false}
            >
              {layoutJSON?.map((widget) => {
                if (widget.widgetType === widgetTypes.IconLauncher)
                  return (
                    <div key={widget.id} data-grid={widget} style={{ padding: "0px", zIndex: 1 }}>
                      <IconLauncher widget={widget} />
                    </div>
                  );
                if (widget?.widgetType === "calendarview")
                  return (
                    <div key={widget.id} data-grid={widget} style={{ padding: "0px", zIndex: flag-- }}>
                      <Calendar widget={widget} activeDashboardId={activeDashboard?.id} forceRefresh={forceRefresh} />
                    </div>
                  );
                if (widget?.widgetType === "banner")
                  return (
                    <div key={widget.id} data-grid={widget} style={{ padding: "0px" }}>
                      <BannerPreview
                        widget={widget}
                        smartviewsConfig={smartviewsConfig}
                        activeDashboardId={activeDashboard?.id}
                      />
                    </div>
                  );
                if (widget?.widgetType === "webview")
                  return (
                    <div key={widget.id} data-grid={widget} style={{ padding: "0px", zIndex: 1 }}>
                      <WebView configData={widget} />
                    </div>
                  );
                return (
                  <div key={widget.id} data-grid={widget} style={{ padding: "0px" }}>
                    {!isRestrictedWidget(widget.config) && (
                      <Widget
                        widget={widget}
                        smartviewsConfig={smartviewsConfig}
                        activeDashboardId={activeDashboard?.id}
                        forceRefresh={forceRefresh}
                      />
                    )}
                  </div>
                );
              })}
            </ResponsiveGridLayout>
          </div>
        </>
      )}
    </div>
  );
};

export default Dashboard;
